import React from "react"
import { NEW_ITEM, TRUE_WISH } from "constants/feed"
import EventIcon from "components/atoms/_icons/EventIcon"
import TrueWishIcon from "components/atoms/_icons/TrueWishIcon"
import FeedNewItemSummary from "components/molecules/FeedNewItemSummary"
import FeedTrueWishSummary from "components/molecules/FeedTrueWishSummary"
import { SummaryComponentProps } from "components/organisms/FeedCard/index"
import FeedNewItemCard from "components/organisms/FeedCard/FeedNewItemCard"
import FeedTrueWishCard from "components/organisms/FeedCard/FeedTrueWishCard"

export type FeedItemCard<T extends FeedType> = {
  feed: Extract<WishamFeed, { type: T }> extends never ? WishamFeed : Extract<WishamFeed, { type: T }>;
  index: number;
}

export const feedCardMap: {
  [T in FeedType]: React.FC<FeedItemCard<T>>;
} = {
  [NEW_ITEM]: FeedNewItemCard as React.FC<FeedItemCard<"NEW_ITEM">>,
  [TRUE_WISH]: FeedTrueWishCard as React.FC<FeedItemCard<"TRUE_WISH">>
}

export const feedTitleIconMap: {
  [T in FeedType]: React.ReactNode;
} = {
  [NEW_ITEM]: <EventIcon/>,
  [TRUE_WISH]: <TrueWishIcon/>
}

export const feedSummaryComponentMap: {
  [T in FeedType]: React.FC<SummaryComponentProps<T>>;
} = {
  NEW_ITEM: NewItemSummary,
  TRUE_WISH: TrueWishSummary
}

function NewItemSummary({ info, index }: { info: NewItemFeed; index: number }) {
  return <FeedNewItemSummary {...info.item} index={index}/>
}

function TrueWishSummary({ info }: { info: TrueWishFeed }) {
  return <FeedTrueWishSummary {...info.trueWish}/>
}
